export const CONSENT_DECIDED = 'DECIDED';
export const CONSENT_DISPLAY = 'DISPLAY';
export const CONSENT_DISPLAY_AGAIN = 'AGAIN';
export const CONSENT_SKIPPED = 'SKIPPED';
